import { FeatureFlagVariantKeys } from './featureFlagVariantKeys';
import { useEvaluatedFeatureFlagsQuery } from './useEvaluatedFeatureFlagsQuery';

export function useFeatureFlagVariant(
    key: FeatureFlagVariantKeys,
    defaultValue: string | null
): string | null {
    const { data } = useEvaluatedFeatureFlagsQuery();

    if (data === undefined) {
        return defaultValue;
    }

    const value = data[key];
    return typeof value === 'string' ? value : defaultValue;
}
